module.exports = __webpack_public_path__ + "static/media/shopping-cart.c6cf4319.svg";